import { ALL_IP_FIELDS } from './calendarConstants';

/**
 * Compute the new day data after updating a single field.
 *
 * - ipData fields (periodDay, inseminationDay, etc.): merged into ipData object.
 *   If all ipData fields end up false, removes ipData entirely (matches RPC transform).
 * - Top-level fields (note): set directly on the day data object.
 *
 * @param {object} currentDayData - Current day data from Redux (e.g. { ipData: { periodDay: true }, note: '...' })
 * @param {string} field - The field to update (e.g. 'periodDay', 'note')
 * @param {any} value - The new value
 * @returns {object} The new day data to dispatch to Redux
 */
export function computeNewDayData(currentDayData, field, value) {
  const newDayData = { ...currentDayData };

  if (ALL_IP_FIELDS.includes(field)) {
    // ipData boolean field — merge into ipData
    const currentIpData = currentDayData?.ipData || {};
    const newIpData = { ...currentIpData, [field]: value };

    // If ALL ipData fields are now false, remove ipData entirely (matches RPC transform)
    const hasAnyTrue = ALL_IP_FIELDS.some(f => newIpData[f] === true);
    if (hasAnyTrue) {
      newDayData.ipData = newIpData;
    } else {
      delete newDayData.ipData;
    }
  } else {
    // Top-level field (e.g. note) — set directly on the day object
    newDayData[field] = value;
  }

  return newDayData;
}
